'use strict';
import template from './mx-grid-control-panel.component.html';
import { GroupType } from '../../../model/enumerations';

export class MxDataControlPanelCtrl {
	static $inject = [
		'mx.internationalization',
		'mx.shell.KeyboardNavigationService',
		'$scope',
		'$timeout',
		'mx.shell.SidePanelService',
		'mx.shell.ContextService',
		'mx.SolutionBuilderAgent.ContextSelectionService',
		'mx.shell.SearchProviderService',
		'mx.shell.EventService',
	];

	constructor(i18n, keyboardNavigationService, $scope, $timeout, sidePanelService, contextService, contextSelectionService, searchService, eventService) {
		Object.assign(this, {
			i18n,
			keyboardNavigationService,
			$scope,
			$timeout,
			sidePanelService,
			contextService,
			contextSelectionService,
			searchService,
			eventService,
		});

		// TODO: remove searchService and Search Event when SearchPage will be using generic grid
		eventService.subscribeTo(
			mx.shell.EventCodes.Search,
			(e, searchOptions) => {
				searchOptions = searchOptions || {};
				if (!this.grid.personalizationKey || this.grid.personalizationKey !== searchOptions.uiToken) {
					return;
				}
				this.grid.executor.preprocessors.advanceSearchPreprocessor.conditions = searchOptions.searchForm.getGroup(GroupType.QueryBuilder)?.toJSON();
				this.grid.executor.preprocessors.advanceSearchPreprocessor.filters = searchOptions.filters;
			},
			$scope
		);
	}

	get disabled() {
		return this.executorGrid.disabled;
	}

	get readOnly() {
		return this.executorGrid.readOnly || this.disabled;
	}

	get isGridButtonsVisible() {
		return (
			this.grid &&
			(!this.grid.addButtonHidden || (!this.grid.createButtonHidden && this.grid.createItems.length) || !this.grid.removeButtonHidden || !this.grid.deleteButtonHidden)
		);
	}

	$onChanges(changes) {
		if (changes.grid && changes.grid.currentValue) {
			const grid = changes.grid.currentValue;
			this.createButtons = grid.createItems.map((item) => {
				return {
					label: this.i18n.getFormatted('solutionBuilderAgent.common.create_new_name', item._displayName || ''),
					context: item,
					onItemClick: this.onCreateButtonClick.bind(this),
				};
			});

			if (this.grid.showSelectAll) {
				grid.executor.addSelectionHandler(({ allSelectedRows, allEntitiesSelected }) => {
					this.showResetSelection = allSelectedRows.length > 0;
					this.showSelectEntireDataSet = allSelectedRows.length > 0 && !allEntitiesSelected;
				});
			}
		}
	}

	$postLink() {
		this.keyboardNavigationService.registerKey([
			{
				// Scope: $scope,
				key: 'alt+shift+i',
				// NameInTemplate: 'searchHint',
				description: this.i18n.get('solutionBuilderAgent.components.mx-data-control-panel.search'),
				onRegister: () => {
					this.$scope.searchHint = '⇑+i';
				},
				callback: () => {
					this.$timeout(function () {
						$('mx-grid-control-panel input:visible').focus();
					});
				},
			},
			{
				// Scope: $scope,
				key: 'alt+shift+r',
				hint: '⇑+r',
				// NameInTemplate: 'advSearchHint',
				description: this.i18n.get('solutionBuilderAgent.components.mx-data-control-panel.advancedSearch'),
				onRegister: () => {
					this.$scope.advSearchHint = '⇑+r';
				},
				callback: () => {
					this.$timeout(() => {
						const closeSearch = $('.mx-shell-sidebar--close-btn:visible');

						if (closeSearch.length) {
							closeSearch.click();
						} else {
							this.onAdvancedSearchClick();
						}
					});
				},
			},
		]);
	}

	setAsDraft() {
		if (this.mxForm) {
			this.mxForm.setDirty();
		}
	}

	onCreateButtonClick(event, item) {
		this.grid.onCreateButtonClick(item.context);
	}

	onAdvancedSearchClick() {
		this.searchService.openAdvancedSearch({
			context: {
				name: this.grid.executor.dataQuery.Name,
				title: this.grid.executor.dataQuery.Name,
				datasource: this.grid.executor.dataQuery.Id,
				parameters: {},
			},
			uiToken: this.grid.personalizationKey,
		});
	}
}

export default {
	bindings: {
		grid: '<',

		settingsOpened: '=?',
	},
	require: {
		executorGrid: '?^mxExecutorGrid',
		mxForm: '?^mxForm',
	},
	controller: MxDataControlPanelCtrl,
	controllerAs: 'vm',
	template: template,
};
